var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-ecommerce"}},[_c('b-row',[_c('b-col',{staticClass:"col-md-7 col-sm-12"},[_c('main-vero-admin-line-cross')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }